/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
// import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Hidden from '@material-ui/core/Hidden';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import { DariBreadcrumbs, Helmet, DariImage } from 'aurora-components';
import { CleverTapProfileTermsConditions } from 'aurora-utils/cleverTap.eventhelper';
import Template from '../template';

import styles from './styleJss';
import './style.css';

function PropertyDetail({ classes }) {
  const { search } = useLocation();
  const lang = new URLSearchParams(search).get('lang') || localStorage.getItem('lang');
  const isMobile = new URLSearchParams(search).get('mobile');
  useEffect(() => {
    CleverTapProfileTermsConditions();
  }, []);
  return (
    <>
      <Helmet metaObject='term_and_condition' />
      <Template>
        <Hidden smDown>
          <DariBreadcrumbs
            paths={[
              { text: <FormattedMessage {...messages.back_to_home} />, to: '/app/home' },
              { text: <FormattedMessage {...messages.terms_conditions} /> },
            ]}
          />
        </Hidden>
        {!isMobile && isMobile !== true && (
          <Hidden smUp>
            <div className={classes.mobiletitlehead}>
              <Link href='/app/applications'>
                <DariImage
                  name='BackClose.svg'
                  alt='BackClose'
                  className={classes.mobilebackarrow}
                  aria-hidden='true'
                />
              </Link>
              <Typography variant='h6' component='h2'>
                {lang === 'ar'
                  ? 'شركة المتطورة للخدمات العقارية ذ.م.م ذ.م.م - شروط خدمة داري'
                  : 'ADRES LLC – Dari Service Terms of Service'}
              </Typography>
            </div>
          </Hidden>
        )}
        <Grid container spacing={3} className={classes.mainTCcontent}>
          <Grid item xs={12} md={4}>
            <div className={classes.tableOfContentsFrame}>
              <Typography variant='body1' component='h2'>
                <FormattedMessage {...messages.table_of_contents} />
              </Typography>
              <ol>
                <li>
                  <Link href='#title1'>{lang === 'ar' ? 'مقدمة' : 'Introduction'}</Link>
                </li>
                <li>
                  <Link href='#title2'>{lang === 'ar' ? 'استخدام الخدمات ' : 'Using the Services'}</Link>
                </li>
                <li>
                  <Link href='#title3'>{lang === 'ar' ? 'الخدمات المدفوعة ' : 'Paid-for Services '}</Link>
                </li>
                <li>
                  <Link href='#title4'>
                    {lang === 'ar' ? '	المحتوى المخالف أو غير القانوني  ' : 'Infringing or unlawful Content'}
                  </Link>
                </li>
                <li>
                  <Link href='#title5'>
                    {lang === 'ar'
                      ? 'الملكية والاستخدام وحقوق الملكية الفكرية  '
                      : 'Ownership, use and intellectual property rights'}
                  </Link>
                </li>
                <li>
                  <Link href='#title6'>
                    {lang === 'ar'
                      ? '  دقة المعلومات وتوفر  خدمات '
                      : 'Accuracy of information and availability of the Services '}
                  </Link>
                </li>
                <li>
                  <Link href='#title7'>
                    {lang === 'ar' ? 'الارتباطات التشعبية ومواقع الجهات الخارجية ' : 'Hyperlinks and third-party sites'}
                  </Link>
                </li>
                <li>
                  <Link href='#title8'>
                    {lang === 'ar' ? '	الضمانات والقيود على مسؤوليتنا ' : 'Warranties & limitation on our liability'}
                  </Link>
                </li>
                <li>
                  <Link href='#title9'>{lang === 'ar' ? '	أحداث خارجة عن إرادتنا  ' : 'Events beyond our control'}</Link>
                </li>
                <li>
                  <Link href='#title10'>{lang === 'ar' ? '	متفرقات' : 'Miscellaneous'}</Link>
                </li>
                <li>
                  <Link href='#title11'>
                    {lang === 'ar' ? '	النزاعات  والقانون الحاكم ' : 'Disputes & Governing Law '}
                  </Link>
                </li>
              </ol>
            </div>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography variant='h5' component='h1' className={classes.Title}>
              {lang === 'ar'
                ? 'شركة المتطورة للخدمات العقارية ذ.م.م - شروط خدمة داري'
                : 'ADRES LLC – Dari Service Terms of Service'}
            </Typography>
            <ol className='tcFirstOrderList'>
              <li id='title1'>
                <Typography variant='subtitle1' className={classes.headsubtitle}>
                  {lang === 'ar' ? 'مقدمة' : 'Introduction'}
                </Typography>
                <ol>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        <b>حول هذه الشروط</b>: تحكم شروط الخدمة هذه ("<b>الشروط</b>") وصولك إلى خدمة داري واستخدامك لها
                        وأي خدمات ذات صلة متاحة لك من خلال خدمة داري (يُشار إليها مجتمعةً بـ "<b>الخدمات</b>") وأي نصوص
                        وصور وفيديو وصوت أو غيرها من محتوى الوسائط المتعددة، أو البرامج أو المعلومات أو المواد الأخرى
                        المتاحة من خلال الخدمات ("<b>المحتوى</b>").
                      </span>
                    ) : (
                      <span>
                        <b>About these Terms</b>: These Terms of Service ("<b>Terms</b>") govern your access to, and use
                        of, Dari and any related services made available to you through Dari (collectively, the "
                        <b>Services</b>") and any text, images, video, audio or other multimedia content, software or
                        other information or material made available through the Services ("<b>Content</b>").
                      </span>
                    )}
                  </li>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>من نحن</b>: يتم توفير خدمة داري من قبل شركة المتطورة للخدمات العقارية ذ.م.م ("
                        <b>شركة المتطورة</b> " أو "<b>نحن</b>")،وشركة المتطورة للخدمات العقارية ذ.م.م هي شركة ذات
                        مسؤولية محدودة مع مكتبها المسجل في مبنى المركز الرئيسي لشركة الدار، شاطئ الراحة غرب 11، شاطئ
                        الراحة. وشركة المتطورة للخدمات العقارية ذ.م.م مرخصة من قبل دائرة البلديات والنقل بأبوظبي ("
                        <b>دائرة البلديات والنقل</b>") لإتاحة بعض الخدمات المتعلقة بالعقارات التي تقدمها دائرة البلديات
                        والنقل للجمهور رقميًا من خلال خدمات داري.{' '}
                      </span>
                    ) : (
                      <span>
                        <b>Who we are</b>: Dari is provided by Advanced Real Estate Services LLC (“<b>ADRES LLC</b>”, “
                        <b>us</b>” or “<b>we</b>”). ADRES LLC is a limited liability company with its registered office
                        at Aldar HQ Building, RBW 11, Al Raha Beach. ADRES LLC is authorised by the Abu Dhabi Department
                        of Municipalities and Transport (<b>“DMT”</b>) to make certain real estate related services
                        provided by DMT available to the public digitally through the Dari Services.
                      </span>
                    )}
                  </li>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>تواصل معنا</b>: يتوفر فريق خدمة العملاء لدينا للمساعدة إذا كانت لديك أسئلة حول هذه الشروط أو
                        أي جانب من جوانب الخدمات. ولطلب المساعدة، يرجى الاتصال بفريقنا على{' '}
                        <a href='mailto:support@dari.ae'> support@dari.ae</a>
                      </span>
                    ) : (
                      <span>
                        <b>Contacting Us</b>: Our customer service team are available to assist if you have questions
                        about these Terms or any aspect of the Services. To seek assistance, please contact our team at{' '}
                        <a href='mailto:support@dari.ae'> support@dari.ae</a>
                      </span>
                    )}
                  </li>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        <b>قبول هذه الشروط</b>: بالتسجيل في الخدمات أو استخدامها أو الوصول إليها بطريقة أخرى، فإنك توافق
                        على الدخول في هذه الشروط مع شركة المتطورة للخدمات العقارية ذ.م.م وأما إذا لم توافق على هذه
                        الشروط، فلا يمكنك حينئذٍ استخدام الخدمة أو الوصول إلى أي محتوى.ويجوز لنا منع أو تعليق وصولك إلى
                        الخدمات (كليًا أو جزئيًا) إذا كنت لا تمتثل لهذه الشروط أو أي قانون معمول به.وبالنسبة لأية خدمات
                        نوفرها لك مرتبطة بخدمة مقدمة من سلطة حكومية (على سبيل المثال، دائرة البلديات والنقل) فإنك توافق
                        أيضًا على الالتزام بأي شروط توفرها هذه السلطة الحكومية فيما يتعلق بالخدمات المعمول بها.{' '}
                      </span>
                    ) : (
                      <span>
                        <b>Acceptance of these Terms</b>: By signing up for, or otherwise using or accessing the
                        Services, you agree to enter into these Terms with ADRES LLC. If you do not agree to these
                        Terms, then you must not use the Services or access any Content. We may prevent or suspend your
                        access to the Services (in whole or in part) if you do not comply with these Terms or any
                        applicable law. For any Services we make available to you that are connected to a service
                        provided by a governmental authority (for example, DMT) then you also agree to abide by any
                        terms provided by such governmental authority related to the applicable Services.
                      </span>
                    )}
                  </li>
                </ol>
              </li>
              <li id='title2'>
                <Typography variant='subtitle1' className={classes.headsubtitle}>
                  {lang === 'ar' ? 'استخدام الخدمات ' : 'Using the Services'}
                </Typography>
                <ol>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        <b>قيود العمر</b>: من أجل استخدام الخدمات، فأنت تؤكد أن عمرك 21 عامًا أو أكبر، أو إذا لم تكن
                        كذلك، فقد حصلت على موافقة ولي الأمر أو الوصي على استخدام الخدمات والدخول في هذه الشروط.{' '}
                      </span>
                    ) : (
                      <span>
                        <b>Age Restrictions</b>: In order to use the Services, you confirm that are 21 years or older
                        or, if you are not, you have obtained parental or guardian consent to use the Services and enter
                        into these Terms.{' '}
                      </span>
                    )}
                  </li>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        <b>الأمان والبيانات</b>: أنت مسؤول عن التأكد من أن تفاصيل الحساب تبقى آمنة وسرية وأن أي معلومات
                        تسجيل وحساب ترسلها إلى شركة المتطورة للخدمات العقارية ذ.م.م صحيحة ودقيقة وكاملة.وعند تسجيل
                        الدخول إلى الخدمات، ستتلقى كلمة مرور لمرة واحدة على رقم الهاتف المتحرك الذي تستخدمه للتسجيل أو
                        إشعار UAEPASS.ويجب ألا تشاركها مع أي شخص آخر.وإذا كان لدينا سبب للاعتقاد باحتمال حدوث خرق للأمن
                        أو إساءة استخدام الخدمات من خلال حسابك أو استخدام كلمة المرور لمرة واحدة أو بيانات اعتماد تسجيل
                        الدخول، فقد نقوم بتعليق حسابك أو إنهائه. وسيتم التعامل مع أي معلومات شخصية تقدمها لنا أو نقوم
                        بمعالجتها كجزء من الخدمات وفقًا لسياسة الخصوصية المتاحة لدينا على{' '}
                        <a href='https://www.dari.ae/app/privacy-policy'> https://www.dari.ae/app/privacy-policy</a>
                      </span>
                    ) : (
                      <span>
                        <b>Security & Data</b>: You are responsible for making sure that account details are kept secure
                        and confidential and that any registration and account information that you submit to ADRES LLC
                        is true, accurate, and complete. When you login to the Services you will receive an OTP to the
                        mobile number that you use for registration or a UAEPASS notification. You must not share this
                        with any other person. If we have reason to believe there is likely to be a breach of security
                        or misuse of the Services through your account or the use of your OTP or login credentials, we
                        may suspend or terminate your account. Any personal information you provide to us or we process
                        as part of the Services will be handled in accordance with our Privacy Policy available at
                        <a href='https://www.dari.ae/app/privacy-policy'> https://www.dari.ae/app/privacy-policy</a>
                      </span>
                    )}
                  </li>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>الأنشطة المحظورة</b>: لا يجوز لك استخدام خدماتنا:
                      </span>
                    ) : (
                      <span>
                        <b>Prohibited Activities</b>: You may not use our Services:
                      </span>
                    )}
                    <ol>
                      <li>
                        {lang === 'ar' ? 'لأي غرض احتيالي أو غير قانوني؛ ' : 'for any fraudulent or unlawful purpose.'}
                      </li>
                      <li>
                        {lang === 'ar'
                          ? 'بأي طريقة تنتهك حقوق أي طرف ثالث (بما في ذلك حقوق الملكية الفكرية والخصوصية)؛'
                          : 'in any manner that infringes the rights of any third party (including intellectual property and privacy rights).'}
                      </li>
                      <li>
                        {lang === 'ar'
                          ? '	لإيذاء أو محاولة إيذاء أي شخص، أو التنمر أو الإهانة أو التخويف أو إذلال أي شخص؛'
                          : 'to harm or attempt to harm any person, or to bully, insult, intimidate or humiliate any person.'}
                      </li>
                      <li>
                        {lang === 'ar'
                          ? '	لنقل، أو الحث على إرسال، أي مادة إعلانية أو ترويجية غير مطلوبة أو غير مصرح بها أو أي شكل آخر من أشكال المراسلات المماثلة (البريد العشوائي)؛'
                          : 'to transmit, or procure the sending of, any unsolicited or unauthorised advertising or promotional material or any other form of similar solicitation (spam).'}
                      </li>
                      <li>
                        {lang === 'ar'
                          ? '	للانخراط في أي نشاط يتداخل مع أو يعطل أداء الخدمات، أو الخوادم أو الشبكات التي تستضيف الخدمات، أو محاولة التحايل على ميزات الخدمات المتعلقة بالأمان أو تعطيلها أو التدخل فيها؛ '
                          : 'to engage in any activity that interferes with or disrupts the performance of the Services, or servers or networks that host the Services, or attempt to circumvent, disable or otherwise interfere with security-related features of the Services. '}
                      </li>
                      <li>
                        {lang === 'ar'
                          ? 'لنقل أي بيانات أو إرسال أو تحميل أي مواد تحتوي على فيروسات مثل (أحصنة طروادة  ديدان حاسوبية  راصد لوحة المفاتيح) أو برامج تجسس أو برامج إعلانية أو أي برامج ضارة أخرى أو رمز كمبيوتر مشابه مصمم للتأثير سلبًا على تشغيل أي برنامج أو جهاز كمبيوتر'
                          : 'to transmit any data, send or upload any material that contains viruses, Trojan horses, worms, time-bombs, keystroke loggers, spyware, adware or any other harmful programs or similar computer code designed to adversely affect the operation of any computer software or hardware.'}
                      </li>
                      <li>
                        {lang === 'ar'
                          ? 'لتسهيل أو السماح لأي  ("robot", "bot", "spider", "scraper" ) أو أي جهاز أو برنامج أو أداة أو خوارزمية أو رمز أو عملية أو منهجية مؤتمتة للوصول إلى/أو الحصول على نسخ أو مراقبة أو إعادة نشر أي جزء من الخدمات أو المحتوى'
                          : 'to facilitate or permit any "robot", "bot", "spider", "scraper" or other automated device, program, tool, algorithm, code, process or methodology to access, obtain, copy, monitor or republish any portion of the Services or the Content.'}
                      </li>
                      <li>
                        {lang === 'ar'
                          ? '2.3.8	التلاعب أو التحديث أو التغيير أو محاولة الحصول على وصول غير مصرح به إلى أي جزء من الخدمات أو أي برامج أو أنظمة أو تقنية شركة المتطورة للخدمات العقارية ذ.م.م  مستخدمة لتوفير الخدمات ما لم يُسمح بذلك صراحةً شركة المتطورة للخدمات العقارية ذ.م.م ؛ '
                          : 'tamper with, update, change or attempt to gain unauthorised access to any part of the Services or any ADRES LLC software, systems or technology used to provide the Services unless expressly permitted to do so ADRES LLC.'}
                      </li>
                      <li>
                        {lang === 'ar'
                          ? 'الوصول إلى كل الخدمات أو أي جزء منها من أجل بناء منتج أو خدمة تتنافس مع الخدمات؛ أو لأي غرض آخر ينتهك هذه الشروط أو أي شروط أو سياسات تفرضها أي سلطة حكومية ذات صلة (على سبيل المثال ، دائرة البلديات والنقل)'
                          : 'access all or any part of the Services in order to build a product or service which competes with the Services; or for any other purpose that is in violation of these Terms or any conditions or policies imposed by any relevant governmental authority (for example, DMT).'}
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li id='title3'>
                <Typography variant='subtitle1' className={classes.headsubtitle}>
                  {lang === 'ar' ? ' الخدمات المدفوعة ' : 'Paid-for Services '}
                </Typography>
                <ol>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        من خلال خدمات “داري”. يمكنك أن تطلب أن نقدم لك بعض الخدمات الأخرى حيث توجد تكلفة مرفقة ("الخدمات
                        المدفوعة")، وتشمل الخدمات المدفوعة، على سبيل المثال، خدمات توثيق وتسجيل الإيجار، وإصدار
                        الشهادات، والخدمات المتعلقة بمعاملات بيع العقارات والخدمات الأخرى التي قد نوفرها من وقت لآخر.
                      </span>
                    ) : (
                      <span>
                        Through the Dari Services, you may request that we provide you with certain other services where
                        there is a cost attached (“<b>Paid-for Services</b>”). Paid-for Services include, for example,
                        Tawtheeq and lease registration services, the issuing of certificates, services related to
                        property sale transactions and other services that we may make available from time to time.{' '}
                      </span>
                    )}
                  </li>
                  <li>
                    {lang === 'ar'
                      ? '	بعد إكمال وتقديم طلب/نموذج للحصول على الخدمات المدفوعة، سيتم تحصيل الرسوم ذات الصلة للخدمات المدفوعة بالكامل.وقد تشمل رسوم الخدمات المدفوعة مقابل الرسوم الرسمية المطبقة من قبل سلطة حكومية ذات صلة (على سبيل المثال دائرة البلدية والنقل) أو رسوم داري للخدمات المدفوعة أو مزيج من الاثنين.   '
                      : 'After you complete and submit an application / request for Paid-for Services you will be charged the relevant fees for the Paid-for Services in full. Fees for Paid-for Services may comprise of the official charges applied by a relevant governmental authority (for example DMT), a Dari fee for the Paid-for Services or a combination of the two.   '}
                  </li>
                  <li>
                    {lang === 'ar'
                      ? 'جميع رسوم الخدمات المدفوعة غير قابلة للاسترداد إلا في الأحوال التالية: '
                      : 'All fees for Paid-for Services are non-refundable unless:'}
                    <ol>
                      <li>
                        {lang === 'ar'
                          ? '	تم رفض طلبك/نموذجك من قبل السلطة الحكومية ذات الصلة (على سبيل المثال، إذا لم يتم إصدار الشهادة ذات الصلة التي طلبتها من قبل السلطة الحكومية)، وفي مثل هذه الظروف، سيتم إصدار استرداد كامل لك '
                          : 'your application / request is rejected by the relevant government authority (for example, if the relevant certificate that you have requested is not issued by the government authority). In such circumstances, you will be issued with a full refund. '}
                      </li>
                      <li>
                        {lang === 'ar'
                          ? '	في حالة صفقة بيع عقار، إذا تمت الموافقة المسبقة على طلبك و/أو تم حجز موعد لتوقيع العقد ولكنك قررت عدم إكمال المعاملة. وفي مثل هذه الظروف، قد يحق لك استرداد جزء من المبلغ. '
                          : 'in the case of a property sale transaction, if you have had your application pre-approved and/or an appointment is booked for contract signing but you decide not to complete the transaction. In such circumstances, you may be entitled to a partial refund.  '}
                      </li>
                    </ol>
                  </li>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        يجب توجيه جميع طلبات الاسترداد إلى <a href='mailto:refund@dari.ae'>refund@dari.ae</a> عندما
                        يتكون جزء من رسوم الخدمة المدفوعة مقابل الرسوم المطبقة من قبل سلطة حكومية، فقد تتلقى أي مبالغ
                        مستردة في معاملتين منفصلتين.{' '}
                      </span>
                    ) : (
                      <span>
                        All refund requests should be directed to <a href='mailto:refund@dari.ae'>refund@dari.ae</a>.
                        Where part of the fees for a Paid-for Service consists of charges applied by a governmental
                        authority, you may receive any refunded amounts in two separate transactions.{' '}
                      </span>
                    )}
                  </li>
                </ol>
              </li>
              <li id='title4'>
                <Typography variant='subtitle1' className={classes.headsubtitle}>
                  {lang === 'ar' ? 'المحتوى المخالف أو غير القانوني  ' : 'Infringing or unlawful Content'}
                </Typography>
                <ol>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>التخفيف من المحتوى المخالف</b>: ويجوز لنا، وفقًا لتقديرنا الخاص:
                      </span>
                    ) : (
                      <span>
                        <b>Mitigating Infringing Content</b>: We may, in our sole discretion:
                      </span>
                    )}
                    <ol>
                      <li>
                        {lang === 'ar'
                          ? 'حذف أو تعليق الحسابات التي تُستخدم بطريقة غير مناسبة أو تنتهك هذه الشروط '
                          : 'delete or suspend accounts which are being used in an inappropriate manner or in breach of these Terms.'}
                      </li>
                      <li>
                        {lang === 'ar'
                          ? '	تحديد وإزالة أي محتوى نراه غير مناسب أو تشهيري أو ينتهك حقوق الملكية الفكرية أو ينتهك بخلاف ذلك القسم  2.3 من هذه الشروط. '
                          : 'identify and remove any Content that we deem is inappropriate, defamatory, infringes intellectual property rights or is otherwise in breach of Section ‎2.3 of these Terms. '}
                      </li>
                    </ol>
                  </li>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>البحث عن المحتوى المخالف</b>: إذا حددت أي محتوى ينتهك هذه الشروط، فيجب عليك الاتصال بنا على
                        الفور باستخدام تفاصيل الاتصال الموضحة في القسم 1.3 من هذه الشروط.{' '}
                      </span>
                    ) : (
                      <span>
                        <b>Finding Infringing Content</b>: If you identify any Content which is in breach of these
                        Terms, you should contact us immediately using the contact details set out in Section ‎1.3 of
                        these Terms.
                      </span>
                    )}
                  </li>
                </ol>
              </li>
              <li id='title5'>
                <Typography variant='subtitle1' className={classes.headsubtitle}>
                  {lang === 'ar'
                    ? 'الملكية والاستخدام وحقوق الملكية الفكرية  '
                    : 'Ownership, use and intellectual property rights'}
                </Typography>
                <ol>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>الملكية</b>: حقوق الملكية الفكرية في الخدمات والمحتوى مملوكة لنا ولمرخصينا، ونحن نحتفظ وكذلك
                        مرخصونا بجميع حقوق الملكية الفكرية (بما في ذلك، على سبيل المثال لا الحصر، جميع حقوق النشر
                        والعلامات التجارية وأسماء المجالات وحقوق التصميم وحقوق قواعد البيانات وبراءات الاختراع وجميع
                        حقوق الملكية الفكرية الأخرى من أي نوع) سواء كانت مسجلة أو غير مسجلة في أي مكان في العالم.
                      </span>
                    ) : (
                      <span>
                        <b>Ownership</b>: The intellectual property rights in the Services and in Content are owned by
                        us and our licensors. We and our licensors reserve all our intellectual property rights
                        (including, but not limited to, all copyright, trade marks, domain names, design rights,
                        database rights, patents and all other intellectual property rights of any kind) whether
                        registered or unregistered anywhere in the world.
                      </span>
                    )}
                  </li>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>انتفاء الحق القانوني</b>: ما لم يتم الاتفاق صراحةً، نحن لا نمنحك أي حقوق قانونية في الخدمات
                        أو المحتوى.أنت توافق على عدم تعديل أو محاولة التحايل أو حذف أي إشعارات معروضة على الخدمات أو
                        المحتوى (بما في ذلك أي إشعارات ملكية فكرية) وعلى وجه الخصوص، في أي حقوق رقمية أو تقنية أمان أخرى
                        مضمنة أو واردة في الخدمات أو المحتوى.
                      </span>
                    ) : (
                      <span>
                        <b>No Legal Right</b>: Unless expressly agreed, we do not grant you any legal rights in the
                        Services or the Content. You agree not to adjust, try to circumvent or delete any notices
                        displayed on the Services or the Content (including any intellectual property notices) and in
                        particular, in any digital rights or other security technology embedded or contained within the
                        Services or the Content.
                      </span>
                    )}
                  </li>
                </ol>
              </li>
              <li id='title6'>
                <Typography variant='subtitle1' className={classes.headsubtitle}>
                  {lang === 'ar'
                    ? 'دقة المعلومات وتوفر  خدمات '
                    : 'Accuracy of information and availability of the Services '}
                </Typography>
                <ol>
                  <li>
                    {lang === 'ar'
                      ? '	لا نضمن أن يكون موقعنا، أو أي محتوى موجود عليه، متاحًا دائمًا أو ألا يتعرض للانقطاع. ويجوز لنا تعليق أو سحب أو تقييد إتاحة كل أو أي جزء من خدماتنا لأسباب تجارية وتشغيلية، وحيثما أمكن، سنحاول إعطائك إشعارًا معقولاً بأي تعليق أو سحب.'
                      : 'We do not guarantee that our Services, or any Content on it, will always be available or be uninterrupted. We may suspend or withdraw or restrict the availability of all or any part of our Services for business and operational reasons and, where possible, we will try to give you reasonable notice of any suspension or withdrawal.'}
                  </li>
                  <li>
                    {lang === 'ar'
                      ? '	يتم توفير أي محتوى لأغراض المعلومات العامة الخاصة بك فقط ولإبلاغك عنا وعن منتجاتنا وأخبارنا وميزاتنا وخدماتنا ومواقعنا الإلكترونية الأخرى التي قد تكون ذات أهمية، ولكن لم يتم تصميمها وفقًا لمتطلباتك أو ظروفك المحددة، ولا تشكل مشورة فنية أو مالية أو قانونية أو أي نوع آخر من المشورة ولا ينبغي الاعتماد عليها لأي غرض من الأغراض.ويجب عليك دائمًا استخدام حكمك المستقل عند استخدام خدماتنا ومحتوانا. '
                      : 'Any Content is provided for your general information purposes only and to inform you about us and our products and news, features, services and other websites that may be of interest, but has not been tailored to your specific requirements or circumstances. It does not constitute technical, financial or legal advice or any other type of advice and should not be relied on for any purposes. You should always use your own independent judgment when using our Services and Content.'}
                  </li>
                </ol>
              </li>
              <li id='title7'>
                <Typography variant='subtitle1' className={classes.headsubtitle}>
                  {lang === 'ar' ? 'الارتباطات التشعبية ومواقع الجهات الخارجية ' : 'Hyperlinks and third-party sites'}
                </Typography>
                <p>
                  {lang === 'ar'
                    ? 'قد تحتوي الخدمات على ارتباطات تشعبية أو إشارات إلى مواقع ويب وإعلانات جهات خارجية بخلاف الخدمات.ويتم توفير أي من هذه الارتباطات التشعبية أو المراجع لراحتك فقط، وليس لدينا أي سيطرة على إعلانات الجهات الخارجية أو مواقع الويب ولا نقبل أي مسؤولية قانونية عن أي محتوى أو مادة أو معلومات واردة فيها.ولا يعني عرض أي ارتباط تشعبي وإشارة إلى أي طرف ثالث أو موقع ويب أننا نؤيد ذلك الطرف الثالث أو منتجاته أو خدماته.وقد يخضع استخدامك لموقع جهة خارجية لبنود وشروط موقع الجهة الخارجية ويكون ذلك على مسؤوليتك الخاصة.'
                    : 'The Services may contain hyperlinks or references to third-party websites and advertising other than the Services. Any such hyperlinks or references are provided for your convenience only. We have no control over third-party advertising or websites and accept no legal responsibility for any content, material or information contained in them. The display of any hyperlink and reference to any third-party or website does not mean that we endorse that third-party, or their products or services. Your use of a third-party site may be governed by the terms and conditions of that third-party site and is at your own risk.'}
                </p>
              </li>
              <li id='title8'>
                <Typography variant='subtitle1' className={classes.headsubtitle}>
                  {lang === 'ar' ? 'الضمانات والقيود على مسؤوليتنا ' : 'Warranties & limitation on our liability'}
                </Typography>
                <ol>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>الضمان المحدود</b>: يتم توفير الخدمات والخدمات المدفوعة "كما هي" وبدون ضمان أو شرط،وعلى وجه
                        الخصوص، قد لا تكون خدماتنا دون انقطاع أو خالية من الأخطاء. ولن تحد هذه الشروط من أي ضمانات غير
                        قابلة للإلغاء أو حقوق حماية المستهلك التي قد تكون مخولة لك بموجب القوانين المعمول بها في دولة
                        الإمارات العربية المتحدة.{' '}
                      </span>
                    ) : (
                      <span>
                        <b>Limited Warranty</b>: The Services and Paid-for Services are provided "as is" and without
                        warranty or condition. In particular, our Services may not be uninterrupted or error-free. These
                        terms will not limit any non-waivable warranties or consumer protection rights that you may be
                        entitled to under applicable laws in the United Arab Emirates.{' '}
                      </span>
                    )}
                  </li>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>استثناءات المسؤولية</b>: باستثناء أي مسؤولية قانونية لا يمكننا استبعادها أو تقييدها كمسألة
                        قانونية (مثل الوفاة أو الإصابة الشخصية الناجمة عن إهمالنا)، لسنا مسؤولين قانونًا عن أي مما يلي:{' '}
                      </span>
                    ) : (
                      <span>
                        <b>Liability Exclusions</b>: Except for any legal responsibility that we cannot exclude or limit
                        as a matter of law (such as for death or personal injury caused by our negligence), we are not
                        legally responsible for any:
                      </span>
                    )}
                    <ol>
                      <li>
                        {lang === 'ar'
                          ? 'الخسائر التي لم تكن متوقعة لك ولنا عند صياغة هذه الشروط '
                          : 'losses that were not foreseeable to you and us when these Terms were formed.'}
                      </li>
                      <li>
                        {lang === 'ar'
                          ? '	الخسائر التي لم تنتج عن أي خرق من جانبنا '
                          : 'losses that were not caused by any breach on our part. '}
                      </li>
                      <li>
                        {lang === 'ar'
                          ? '	أي خسارة في الاستخدام أو البيانات أو الأعمال التجارية أو الأرباح '
                          : 'any loss of use, data, business, or profits.'}
                      </li>
                    </ol>
                  </li>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>سقف المسؤولية</b>: إلى أقصى حد يسمح به القانون المعمول به، يجب أن تكون مسؤوليتنا الإجمالية عن
                        جميع المطالبات المتعلقة بهذه الشروط أكبر مما يلي: (أ) المبالغ التي دفعتها إلى شركة المتطورة
                        للخدمات العقارية ذ.م.م خلال الاثني عشر شهرًا السابقة للمطالبة الأولى؛ أو (ب) 100 درهم إماراتي.
                      </span>
                    ) : (
                      <span>
                        <b>Liability Cap</b>: To the greatest extent permitted by applicable law, our aggregate
                        liability for all claims relating to these Terms shall be the greater of: (a) the amounts paid
                        by you to ADRES LLC during the twelve months prior to the first claim; or (b) AED 100.
                      </span>
                    )}
                  </li>
                </ol>
              </li>
              <li id='title9'>
                <Typography variant='subtitle1' className={classes.headsubtitle}>
                  {lang === 'ar' ? '	أحداث خارجة عن إرادتنا  ' : 'Events beyond our control'}
                </Typography>
                <p>
                  {lang === 'ar'
                    ? 'نحن لسنا مسؤولين تجاهك إذا فشلنا في الامتثال لهذه الشروط بسبب ظروف خارجة عن سيطرتنا المعقولة، بما في ذلك، على سبيل المثال لا الحصر، الإضرابات أو الإغلاق أو النزاعات الصناعية الأخرى؛ انهيار الأنظمة أو الوصول إلى الشبكة؛ فيضان أو حريق أو انفجار أو حادث؛ أو الأوبئة أو الجائحات.       '
                    : 'We are not liable to you if we fail to comply with these Terms because of circumstances beyond our reasonable control, including, but not limited to, strikes, lock-outs or other industrial disputes; breakdown of systems or network access; flood, fire, explosion or accident; or epidemics or pandemics.'}
                </p>
              </li>
              <li id='title10'>
                <Typography variant='subtitle1' className={classes.headsubtitle}>
                  {lang === 'ar' ? '	متفرقات' : 'Miscellaneous'}
                </Typography>
                <ol>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>تغيير الشروط</b>: نقوم بتعديل هذه الشروط من وقت لآخر،وفي كل مرة ترغب في استخدام خدماتنا،
                        يُرجى مراجعة هذه الشروط للتأكد من فهمك للشروط التي تنطبق في ذلك الوقت.{' '}
                      </span>
                    ) : (
                      <span>
                        <b>Variation of Terms</b>: We may amend these Terms from time to time. Every time you wish to
                        use our Services, please check these Terms to ensure you understand the Terms that apply at that
                        time.{' '}
                      </span>
                    )}
                  </li>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>تنوع الخدمات</b>: قد نقوم بتحديث خدماتنا وتغييرها من وقت لآخر لتعكس التغييرات التي تطرأ على
                        احتياجات مستخدمينا وأولويات أعمالنا. حيثما كان ذلك ممكنًا، سنحاول إعطائك إشعارًا معقولاً بأي
                        تغييرات كبيرة تطرأ على أي خدمات مدفوعة.
                      </span>
                    ) : (
                      <span>
                        <b>Variation of Services</b>: We may update and change our Services from time to time to reflect
                        changes to our users' needs and our business priorities. Where possible, we will try to give you
                        reasonable notice of any major changes to any paid-for Services.
                      </span>
                    )}
                  </li>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>التحويل والتنازل</b>: يجوز لنا نقل حقوقنا والتزاماتنا بموجب هذه الشروط إلى منظمة أخرى.سنخبرك
                        دائماً كتابةً في حالة حدوث ذلك وسوف نتأكد من أن النقل لن يؤثر على حقوقك بموجب العقد.لا يُسمح لك
                        بنقل الشروط أو التنازل عنها لأي شخص آخر.{' '}
                      </span>
                    ) : (
                      <span>
                        <b>Transfer & Assignment</b>: We may transfer or assign our rights and obligations under these
                        terms to another organisation. We will always tell you in writing if this happens and we will
                        ensure that the transfer or assignment will not affect your rights under the Terms. You are not
                        permitted to transfer or assign the Terms to anyone else.{' '}
                      </span>
                    )}
                  </li>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>التسويق</b>: يجوز لـنا الاتصال بالمتعاملين عبر الهاتف، أو التواصل معهم عبر قنوات التواصل
                        المختلفة مثل الرسائل النصية، والبريد الإلكتروني، أو رسائل الواتس آب للتسويق لخدماتها وعروضها، ما
                        لم يكن المتعامل قد أبدى عدم رغبته في ذلك، أو سجّل ذلك عبر منصة داري أو أي وسيلة للتواصل معه.{' '}
                      </span>
                    ) : (
                      <span>
                        <b>Marketing</b>: To be able to market our services and offers, we may contact our customers via
                        telephone, or communicate with them via different channels of communication such as text
                        messages, e-mails, or WhatsApp messages, unless the customer has not given their consent to do
                        so, or has opted out of these messages either through registering that on DARI or any other
                        means of communication.{' '}
                      </span>
                    )}
                  </li>
                </ol>
              </li>
              <li id='title11'>
                <Typography variant='subtitle1' className={classes.headsubtitle}>
                  {lang === 'ar' ? '	النزاعات  والقانون الحاكم ' : 'Disputes & Governing Law '}
                </Typography>
                <ol>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>اتصل بنا</b>: سنحاول حل أي نزاعات معك بسرعة وكفاءة.وإذا لم تكن راضيًا عن أي جانب من هذه
                        الشروط ، فيرجى الاتصال بنا في أقرب وقت ممكن باستخدام تفاصيل الاتصال الموضحة في القسم 1.3 من هذه
                        الشروط.{' '}
                      </span>
                    ) : (
                      <span>
                        <b>Contact Us</b>: We will try to resolve any disputes with you quickly and efficiently. If you
                        are not satisfied with any aspect of these Terms, please contact us as soon as possible using
                        the contact details set out in Section 1.3 of these Terms.
                      </span>
                    )}
                  </li>
                  <li>
                    {lang === 'ar' ? (
                      <span>
                        {' '}
                        <b>القانون الحاكم</b>: تنطبق قوانين لدولة الإمارات العربية المتحدة (كما هو مطبق في إمارة أبو
                        ظبي) على هذه الشروط ويجب تقديم جميع النزاعات إلى الاختصاص القضائي الحصري لمحاكم الإمارات العربية
                        المتحدة
                      </span>
                    ) : (
                      <span>
                        <b>Governing Law</b>: The laws of the United Arab Emirates (as applied in the Emirate of Abu
                        Dhabi) apply to these Terms and all disputes shall be submitted to the exclusive jurisdiction of
                        the Courts of the United Arab Emirates.{' '}
                      </span>
                    )}
                  </li>
                </ol>
              </li>
            </ol>
          </Grid>
        </Grid>
      </Template>
    </>
  );
}

PropertyDetail.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PropertyDetail);
